import { useDataChange, useDataFormat } from 'Simple/Data.js'
import View from './view.js'

export default function Logic(props) {
  let value = useDataFormat({
    context: 'app',
    path: 'learn_more',
    format: value => Boolean(value),
    viewPath: props.viewPath,
  })
  let change = useDataChange({
    context: 'app',
    path: 'learn_more',
    viewPath: props.viewPath,
  })

  return <View {...props} onClick={onClick} value={value} />

  function onClick() {
    change(next => {
      next.learn_more = !next.learn_more
    })
  }
}
